export const apt1FR = "<p>Découvrez un <strong>appartement de vacances à Saint-Rémy-de-Provence</strong> idéal pour <strong>4 personnes</strong>, situé au sein de la <strong>Résidence Melody</strong>, une résidence calme et arborée à seulement <strong>10 minutes à pied du centre-ville</strong>.</p>\n" +
  "<h3>🏠 Règlement intérieur</h3>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Appartement non fumeur</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Résidence réservée aux adultes</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Animaux non autorisés</strong></p></li>\n" +
  "</ul>\n" +
  "<h3>⭐ Confort & équipements</h3>\n" +
  "<p>Ce <strong>logement de 60 m²</strong> offre tout le confort nécessaire pour un séjour réussi en Provence :</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Pièce de vie lumineuse</strong> avec <strong>cuisine entièrement équipée</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>2 Chambres avec chacune sa salle de bain privative</strong></p></li>\n" +
  "<li>\n" +
  "<p><strong>Terrasse privée</strong>, parfaite pour les repas en extérieur</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Climatisation</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Wi-Fi haut débit gratuit</strong></p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>🌿 Espace bien-être et détente</h3>\n" +
  "<p>La résidence dispose d’infrastructures pensées pour la relaxation :</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p><strong>Piscine extérieure chauffée</strong> accessible toute l’année</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Jacuzzi</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Grand jardin arboré</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p><strong>Parking gratuit</strong> à proximité immédiate du logement</p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>📍 Emplacement idéal</h3>\n" +
  "<p>Situé au <strong>4 Allée des Amandiers</strong>, l’appartement bénéficie d’une <strong>situation privilégiée</strong> :</p>\n" +
  "<ul>\n" +
  "<li>\n" +
  "<p>Commerces, restaurants et ruelles provençales à <strong>quelques minutes à pied</strong></p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p>Proche des <strong>Alpilles</strong>, des sentiers de randonnée et des sites touristiques de Provence</p>\n" +
  "</li>\n" +
  "<li>\n" +
  "<p>Parfait pour découvrir <strong>Saint-Rémy-de-Provence</strong>, <strong>Les Baux-de-Provence</strong>, ou encore <strong>Avignon</strong></p>\n" +
  "</li>\n" +
  "</ul>\n" +
  "<h3>💛 Un séjour authentique en Provence</h3>\n" +
  "<p>Cet appartement est idéal pour :<br>\n" +
  "✔️ Les couples<br>\n" +
  "✔️ Les voyageurs en quête de calme<br>\n" +
  "✔️ Les séjours bien-être ou découverte</p>\n" +
  "<p>Profitez d’un <strong>séjour reposant</strong>, au cœur d’une résidence chaleureuse mêlant <strong>confort moderne</strong>, <strong>nature</strong> et <strong>authenticité provençale</strong>.</p>"
